import React from "react";

import { Box, TextField, Typography } from "@mui/material";

import { sectionLabelSx } from "./styles";

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const GuidancePanel: React.FC<Props> = ({ value, onChange }) => {
  const isEmpty = !value.trim();
  return (
    <Box>
      <Typography sx={sectionLabelSx}>Feed guidance</Typography>
      <Typography sx={{ fontSize: 12, color: "#5d7782", mb: "8px", lineHeight: 1.55 }}>
        Use this to steer how the AI ranks and filters news. It does not act like a direct search query.
      </Typography>
      <TextField
        fullWidth
        required
        multiline
        minRows={9}
        value={value}
        error={isEmpty}
        helperText={isEmpty ? "Guidance is required" : undefined}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "6px",
            bgcolor: "#fff",
            p: "10px",
            "& fieldset": { borderColor: "#7b92a9" },
            "&:hover fieldset": { borderColor: "#7b92a9" },
            "&.Mui-focused fieldset": { borderWidth: 1, borderColor: "#071f35" }
          },
          "& .MuiOutlinedInput-input": { fontSize: 13, lineHeight: 1.55, color: "#071f35" }
        }}
      />
    </Box>
  );
};
